import { createApiCall } from 'lib/base';

const EDIT_NHSV_WEBHOOK_CONFIG = 'EDIT_NHSV_WEBHOOK_CONFIG';

const apiCall = createApiCall<{ id: string; payload: any }>(
  EDIT_NHSV_WEBHOOK_CONFIG,
  ({ id, payload }) => ({
    endpoint: `api/admin/nhsv/webhook/configs/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default apiCall;
